<template>
  <div id="overlay">
    <div class="text-center">
      <b-spinner class="spinner" style="width: 3rem; height: 3rem;" variant="primary" label="Spinning"></b-spinner>
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "LoadingBar",
  props: {},
  data() {
    return {};
  }
};
</script>
<style scoped>
#overlay {
  position: fixed;
  display: block;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 2000;
}
.spinner {
  position: fixed;
  z-index: 1031;
  top: 50%;
  right: 50%;
  width: 5rem;
  height: 5rem;
}
</style>
